import { render } from "./FeedView.vue?vue&type=template&id=47b7ca8f&scoped=true"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"

import "./FeedView.vue?vue&type=style&index=0&id=47b7ca8f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b7ca8f"]])

export default __exports__